var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('keep-alive',[_c(_vm.currentActiveTab,{tag:"component",attrs:{"tabTitle":_vm.tabTitle,"activeChat":_vm.activeChat,"activeTab":_vm.activeTab},on:{"user-selected":_vm.handleUserSelected,"recentActiveChatUpdate":_vm.recentActiveChatUpdate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }